import request from '@/utils/request';

// 新增合同
export function getContractSave(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/contract/save',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '新增合同失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}
